import i18n from "@/i18n";
import requireAuthorization from "@/routes/helper/requireAuthorization";
import { PermitionEnum } from "@/components/security/Permitions";

export default [
    {
        path: "/styles",
        name: "styles",
        component: () => import("@/components/styles/_Styles.vue"),
        beforeEnter: requireAuthorization,
        meta: {
            permission: PermitionEnum.ViewStylesUI,
            breadcrumbs: {
                icon: "style-icon",
                paths: []
            },
            title: "navbar.style"
        }
    },
    {
        path: "/styles/create",
        name: "createstyle",
        component: () => import("@/components/styles/_StyleForm.vue"),
        beforeEnter: requireAuthorization,
        meta: {
            permission: PermitionEnum.CreateStyles,
            breadcrumbs: {
                icon: "style-icon",
                paths: [
                    ["/styles", i18n.t("navbar.style")]
                ]
            },
            title: "style.create"
        },
        props: true
    },
    {
        path: "/styles/:styleId/update",
        name: "updatestyle",
        component: () => import("@/components/styles/_StyleForm.vue"),
        beforeEnter: requireAuthorization,
        meta: {
            permission: PermitionEnum.UpdateStyles,
            breadcrumbs: {
                icon: "style-icon",
                paths: [
                    ["/styles", i18n.t("navbar.style")]
                ]
            }
        },
        props: true
    },
    {
        path: "/designButtonStyles",
        name: "designButtonStyles",
        component: () => import("@/components/styles/_DesignButtonStyles.vue"),
        beforeEnter: requireAuthorization,
        meta: {
            permission: PermitionEnum.ViewDesignButtonStylesUI,
            breadcrumbs: {
                icon: "style-icon",
                paths: []
            },
            title: "designButtonStyles.title"
        }
    },
    {
        path: "/designButtonStyles/:designButtonStyleId/update",
        name: "updateDesignButtonStyles",
        component: () => import("@/components/styles/_DesignButtonStylesForm.vue"),
        beforeEnter: requireAuthorization,
        meta: {
            permission: PermitionEnum.UpdateDesignButtonStyles,
            breadcrumbs: {
                icon: "style-icon",
                paths: [
                    ["/designButtonStyles", i18n.t("designButtonStyles.title")]
                ]
            }
        }
    },
    {
        path: "/designButtonStyles/create",
        name: "createDesignButtonStyles",
        component: () => import("@/components/styles/_DesignButtonStylesForm.vue"),
        beforeEnter: requireAuthorization,
        meta: {
            permission: PermitionEnum.CreateDesignButtonStyles,
            breadcrumbs: {
                icon: "style-icon",
                paths: [
                    ["/designButtonStyles", i18n.t("designButtonStyles.title")]
                ]
            },
            title: "designButtonStyles.create"
        }
    },
    {
        path: "/channelStyles",
        name: "channelStyles",
        component: () => import("@/components/styles/_ChannelStyles.vue"),
        beforeEnter: requireAuthorization,
        meta: {
            permission: PermitionEnum.ViewStylesUI,
            breadcrumbs: {
                icon: "style-icon",
                paths: []
            },
            title: "channelStyles.title"
        }
    },
    {
        path: "/channelStyles/create",
        name: "createChannelStyles",
        component: () => import("@/components/styles/_ChannelStylesForm.vue"),
        beforeEnter: requireAuthorization,
        meta: {
            permission: PermitionEnum.CreateStyles,
            breadcrumbs: {
                icon: "style-icon",
                paths: [
                    ["/channelStyles", i18n.t("channelStyles.title")]
                ]
            },
            title: "channelStyles.create"
        },
        props: true
    },
    {
        path: "/channelStyles/:styleId/update",
        name: "updateChannelStyles",
        component: () => import("@/components/styles/_ChannelStylesForm.vue"),
        beforeEnter: requireAuthorization,
        meta: {
            permission: PermitionEnum.UpdateStyles,
            breadcrumbs: {
                icon: "style-icon",
                paths: [
                    ["/channelStyles", i18n.t("channelStyles.title")]
                ]
            }
        },
        props: true
    }
];
